/**
 * Scroll Reveal — IntersectionObserver-based reveal animation
 * Adds .visible class to .reveal elements when they enter the viewport.
 * CSS in base.css handles the actual opacity + transform transition.
 */
(function() {
  'use strict';

  var elements = document.querySelectorAll('.reveal');
  if (!elements.length) return;

  /* Respect prefers-reduced-motion: skip animation entirely */
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    elements.forEach(function(el) { el.classList.add('visible'); });
    return;
  }

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  });

  elements.forEach(function(el) { observer.observe(el); });
})();
